import React from "react"
import {NavLink} from "react-router-dom"

const NavLinkMui = React.forwardRef(({...props}, ref) => {
    return <NavLink {...props}  />;
});

export default NavLinkMui;
